// extracted by mini-css-extract-plugin
module.exports = {"container":"Section7_container__PDaHe","content":"Section7_content__Ds3Vf","headline":"Section7_headline__DCpDu","subHeadline":"Section7_subHeadline__qB_kj"};